<template>
  <img
    :src="photo.src"
    :srcset="photo.srcset"
    :sizes="sizes"
    :width="photo.width"
    :height="photo.height"
    :alt="photo.caption[locale === 'zh' ? 'zh' : 'en']"
    :loading="eager ? 'eager' : 'lazy'"
    :fetchpriority="eager ? 'high' : 'auto'"
    decoding="async"
  />
</template>
<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import photos from '@/data/selected-photos.json'
const props = defineProps({ id: { type: String, required: true }, eager: Boolean, sizes: { type: String, default: '(max-width: 640px) 92vw, 50vw' } })
const { locale } = useI18n()
const photo = computed(() => photos[props.id])
</script>
